

export default {
    props: [
        'type',
        'value',
        'description',
        'showIcon'
    ],
}
